import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { WorksheetEntryService } from '@autoinformer/services/WorksheetEntryService';
import { WorksheetActionService } from '@autoinformer/services/WorksheetActionService';

class WorksheetItemServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  createItem(type, worksheet_id, params) {
    if (type === 'start') {
      return WorksheetEntryService.createItem(worksheet_id, params);
    } else {
      return WorksheetActionService.createItem(worksheet_id, params);
    }
  }

  updateItem(type, worksheet_id, id, params) {
    if (type === 'start') {
      return WorksheetEntryService.updateItem(worksheet_id, id, params);
    } else {
      return WorksheetActionService.updateItem(worksheet_id, id, params);
    }
  }

  removeItem(type, worksheet_id, id) {
    if (type === 'start') {
      return WorksheetEntryService.removeItem(worksheet_id, id);
    } else {
      return WorksheetActionService.removeItem(worksheet_id, id);
    }
  }

  createOrUpdateItem(type, worksheet_id, id, params) {
    if (type === 'start') {
      return WorksheetEntryService.createOrUpdateItem(worksheet_id, id, params);
    } else {
      return WorksheetActionService.createOrUpdateItem(worksheet_id, id, params);
    }
  }

  savePosition(type, worksheet_id, id, { position_x, position_y }) {
    return this.updateItem(type, worksheet_id, id, { position_x, position_y });
  }

  updateData(type, worksheet_id, id, data) {
    if (type === 'start') {
      return this.updateItem(type, worksheet_id, id, data);
    } else {
      return this.updateItem(type, worksheet_id, id, { data: data });
    }
  }
}

export const WorksheetItemService = new WorksheetItemServiceClass({
  api_version: 2,
  resource: ''
});
